import api from './api';
import ErrorService from './errorService';


export const tipoClienteService = {

  getTipoCliente: async () => {
        try {
          const response = await ErrorService.withTimeout(api.get(`/TipoCliente`));
          return response.data;      
        } catch (error) {
          ErrorService.handleApiError('Error al obtener:', error);
          throw error;
        }
      },



};